// Invalid 
export const INVALID_MOBILE_NUMBER = 'Invalid Mobile Number.';
export const INVALID_DRIVING_LICENCE = 'Invalid Driving Licence.';
export const INVALID_BANK_ACC_NUMBER = 'Invalid Account No';
export const INVALID_BANK_IFSC = 'Invalid Bank IFSC Code.';
export const INVALID_PAN_NO = 'Invalid Pan No.';
export const INVALID_ADHAR_NO = 'Invalid Aadhar No.';
export const INVALID_RESIDENCE_ADDRESS = 'Invalid Resident Address';
export const INVALID_PERMENET_ADDRESS = 'Invalid Permenet Address';
export const INVALID_ALTERNET_NAME = 'Invalid Alternate Name';
export const INVALID_MOBILE_NO = 'Invalid Mobile No.';
export const INVALID_GUARANTOR_NAME = 'Invalid Guarantor Name';
export const INVALID_GUARANTOR_MOBILE_NO = 'Invalid Guarantor Mobile No.';
export const NO_SPACE = 'No Blank Space Require';
export const INVALID_NAME = 'Invalid Name';
export const INVALID_NUMBER = 'Invalid Number';
export const INVALID_EMAIL = 'Invalid Email';
export const INVALID_PINCODE = 'Invalid Pincode';
export const INVALID_AMMOUNT = 'Invalid Amount';
export const FIELD_IS_REQUIRED = 'Field is Required';
export const INVALID_GST_NO = 'Invalid GST No.';
export const INVALID_SPACE = 'Space is not allowed.';

// Min Validation
export const INVALID_DRIVER_NAME = 'Should be more than 3 characters';